import { FC, useState } from "react"
import { Box, MenuList } from "@mui/material"

import { menuIconsPack } from "@/consts.tsx"
import HeaderItem from "./HeaderItem"
import HeaderThemeItem from "./HeaderThemeItem"
import GeoMenu from "../GeoMenu"
import useGeoProvider from "@shared/GeoProvider"

import {
  handleOpenCloseMenu,
  menuBlurCont,
  sideMenuCont,
} from "./headerMenuStyles"

type Props = {
  isOpenMenu: boolean
}

const HeaderMenu: FC<Props> = ({ isOpenMenu }) => {
  const screenUserWidth = window.screen.width
  const [showCityMenu, setShowCityMenu] = useState(false)
  const [geoData] = useGeoProvider()

  return (
    <MenuList sx={sideMenuCont} style={handleOpenCloseMenu(isOpenMenu)}>
      {/* Выбор города — только на мобиле */}
      {screenUserWidth <= 759 && (
        <Box sx={{
          borderBottom: "1px solid var(--borders)",
          marginBottom: "8px",
        }}>
          <Box
            onClick={() => setShowCityMenu(v => !v)}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "14px 16px",
              cursor: "pointer",
              color: "var(--primary-text)",
              fontSize: "16px",
              fontWeight: 500,
            }}
          >
            <span>📍</span>
            <span>{geoData.city || "Выбрать город"}</span>
            <span style={{ marginLeft: "auto", fontSize: "12px", color: "var(--secondary-text)" }}>
              {showCityMenu ? "▲" : "▼"}
            </span>
          </Box>
          {showCityMenu && (
            <Box sx={{ maxHeight: "300px", overflowY: "auto" }}>
              <GeoMenu onClose={() => setShowCityMenu(false)} />
            </Box>
          )}
        </Box>
      )}
      {menuIconsPack.map((item, i) =>
        item.text === "Тема" ? (
        <HeaderThemeItem item={item} i={i} isOpenMenu={isOpenMenu} key={i} />
        ) : (
        <HeaderItem i={i} item={item} isOpenMenu={isOpenMenu} key={i} />
        ),
      )}
      <Box sx={menuBlurCont} onClick={() => handleOpenCloseMenu(false)} />
    </MenuList>
  )
}

export default HeaderMenu
